import { isDevEnv } from '@libs/utils';
import { Route } from 'react-router';

// TODO: 一部取込機能をlocal or dev or test環境でのみ表示させる。リリースに含めるときに戻す。
export const devFaRoutes = isDevEnv()
  ? [
      <Route
        key="la-article-info-change-import"
        path="la-article-info-change-import"
        lazy={async () => import('./pages/LaArticleInfoChangeImport')}
      />,
      <Route
        key="la-cancel-bef-maturity-import"
        path="la-cancel-bef-maturity-import"
        lazy={async () => import('./pages/LaCancelBefMaturityImport')}
      />,
      <Route
        key="la-contract-info-change-import"
        path="la-contract-info-change-import"
        lazy={async () => import('./pages/LaContractInfoChangeImport')}
      />,
    ]
  : [];
